var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        content: _vm.darkMode ? "切换为日间模式" : "切换为黑夜模式",
        placement: "bottom"
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "page-theme-toggle",
          attrs: {
            type: "button",
            "aria-label": _vm.darkMode ? "日间模式" : "黑夜模式"
          },
          on: { click: _vm.toggleDarkMode }
        },
        [
          _c("i", {
            class: _vm.darkMode ? "el-icon-sunny" : "el-icon-s-opportunity"
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }